import { Chakra } from "@airhelp/react-ui-components";
import CardMobile from "./CardMobile";
import type { CardMobileProps } from "./CardMobile";

const { Flex, Box } = Chakra;

export interface CardsItemMobile extends CardMobileProps {
  _uid: string;
}

export interface CardsMobileProps {
  cards: CardsItemMobile[];
}

const CardsMobile = ({ cards }: CardsMobileProps) => (
  <Box
    gridColumn="span 12"
    overflowX="scroll"
    overflowY="hidden"
    mx={-4}
    sx={{
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }}
  >
    <Flex px={4} py={1}>
      {cards.map(({ _uid, icon, heading, text, subHeading }) => (
        <CardMobile key={_uid} icon={icon} heading={heading} text={text} subHeading={subHeading} />
      ))}
    </Flex>
  </Box>
);

export default CardsMobile;
